



























import Vue from 'vue';
export default Vue.extend({
  name: 'FullscreenSuccess',
  props: {
    text: {
      type: String,
      default: '',
    },
    doneText: {
      type: String,
      required: false,
    },
    secondaryActionText: {
      type: String,
      default: '',
    },
  },
});
